<template>
    <div>
        <div class="shadow-radius productList" v-if="totalCount !== 0">
            <GridHeader v-model="listOptions" />
            <!-- GridResult -->
            <div v-if="!resultLoading" class="row no-margin">
                <div class="col-lg-3 col-md-4 col-sm-6 no-padding" v-for="product in data" :key="product.id">
                    <a class="item-box matchHeight"
                       :href="product.actualProductId +'-'+product.name| slugFilter"
                       v-match-heights="{
                            el: ['.pro-ttl', '.item-box','.product-image']
                        }">
                        <div class="actions">
                            <span class="compareInput">
                                <input type="checkbox"
                                       class="custom-input-button"
                                       v-model="product.addedToComparisonList"
                                       :id="'compare' + product.actualProductId"
                                       @click="toggleCompareState($event, product)" />
                                <label :for="'compare' + product.actualProductId">
                                    <span class="fa">مقایسه</span>
                                </label>
                            </span>
                            <!-- <span class="compareInput">
                                <label>
                                    <input
                                        type="checkbox"
                                        name="compare"
                                        v-model="product.addedToComparisonList"
                                        @click="toggleCompareState($event, product)"
                                    />
                                    مقایسه
                                </label>
                            </span>
                                <!--<span class="avafont-heart"></span>-->
                        </div>
                        <img :src="'https://asset.avajang.com/Product/' + product.imageUri"
                             class="img-responsive product-image"
                             v-if="product.imageUri!=null" />
                        <img src="../../../../wwwroot/img/no-image.jpg"
                             class="img-responsive product-image"
                             v-if="product.imageUri==null" />
                        <div class="pro-ttl">
                            {{ product.persianName}}
                        </div>
                        <del class="discount-price"
                             v-if="product.baseConsumerPrice != null && product.sumOfDiscounts != null && product.sumOfDiscounts > 0
                             ">
                            {{ ((product.baseConsumerPrice + product.sumOfDiscounts) / 10).toLocaleString() | toPersianNumber }}تومان
                        </del>
                        <div class="price-info">
                            <div class="discount"
                                 v-if="
                                 product.baseConsumerPrice !=null &&
                                 product.sumOfDiscounts !=null &&
                                 product.sumOfDiscounts>
                                0
                                ">
                                % {{Math.round(100 * product.sumOfDiscounts / (product.baseConsumerPrice + product.sumOfDiscounts)) | toPersianNumber }} تخفیف
                            </div>
                            <div class="price" v-if="product.baseConsumerPrice != null">
                                {{ Math.round((product.baseConsumerPrice / 10)).toLocaleString() | toPersianNumber }}تومان
                            </div>
                            <div class="unavailable-label" v-if="product.price == null && product.status == 0 ">
                                عدم موجودی در سایت
                            </div>
                            <div class="comingsoon-label" v-if="product.status==1">
                                به زودی
                            </div>
                            <div class="unavailable-label" v-if="product.status==2">
                                عدم موجودی در سایت
                            </div>
                            <div class="unavailable-label" v-if="product.status==3">
                                توقف تولید
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <!-- End GridResult -->
        </div>
        <!-- Pagination -->
        <div class="d-flex justify-content-center w-100" v-if="totalCount !== 0">
            <b-pagination size="md"
                          v-model="listOptions.pageNo"
                          :total-rows="totalCount"
                          :per-page="listOptions.pageSize"
                          prev-text="قبلی"
                          next-text="بعدی" />
        </div>
        <!-- End Pagination -->
        <!-- EmptyTemplate -->
        <div v-if="totalCount === 0 && !resultLoading" class="shadow-radius no-pro-list">
            <img src="../../../../wwwroot/img/comingsoon.svg" class="img-responsive" />
            <p>به‌زودی!</p>
        </div>
        <!-- End EmptyTemplate -->
        <!-- Result Loading -->
        <div class="uploading" v-if="resultLoading">
            <div class="loader">
                <div class="page-loading">
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
        <!-- End Result Loading -->
    </div>
</template>

<script>
    import Vue from 'vue';
    import GridHeader from './gridHeader';
    export default Vue.extend({
        name: 'Grid',
        components: { GridHeader },
        props: {
            resultLoading: {
                type: Boolean,
                default: true
            },
            listOptions: {
                type: Object,
                default: () => { }
            },
            gridData: {
                type: Array,
                default: () => []
            },
            totalCount: {
                type: Number,
                default: 0
            },
            comparisonList: {
                type: Array,
                default: () => []
            },
            compareLimitation: {
                type: Number
            }
        },
        data() {
            return {
                data: [],
                dicountAmount: null
            };
        },
        beforeMount() {
            this.modifyListForCompare();
        },

        methods: {
            toggleCompareState(e, product) {
                if (e.srcElement.checked) {
                    if (this.comparisonList.length === this.compareLimitation) {
                        this.$swal({
                            text: `حداکثر امکان مقایسه ${this.compareLimitation} محصول وجود دارد!`,
                            icon: 'error',
                            confirmButtonText: 'باشه'
                        });
                        setTimeout(() => {
                            product.addedToComparisonList = false;
                        }, 100);
                        return;
                    }
                    this.$emit('onAddToComparisonList', product);
                } else this.$emit('onRmoveFromComparisonList', product.actualProductId);
            },
            modifyListForCompare() {
                this.data = [];
                (this.gridData || []).forEach((product) => {
                    product.addedToComparisonList = !!this.comparisonList.find(
                        (p) => p.actualProductId === product.actualProductId
                    );
                    this.data.push({ ...product });
                });
            }
        },
        filters: {
            slugFilter: function (title) {
                // Change to lower case
                var titleLower = title.toLowerCase();
                // Letter "e"
                title = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
                // Letter "a"
                title = title.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
                // Letter "o"
                title = title.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
                // Letter "u"
                title = title.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');

                title = title.replace(/[^a-z0-9 ^آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهی\s-]/g, '');
                // Letter "d"
                title = title.replace(/đ/gi, 'd');
                // Trim the last whitespace
                title = title.replace(/\s*$/g, '');
                // Change + to "-"
                title = title.replace(/\+/g, '');
                // Change / to "-"
                title = title.replace(/\//g, '');
                // Change whitespace to "-"
                title = title.replace(/\s+/g, '-');
                // Replace multiple "-" to single "-"
                title = title.replace(/-+/g, '-');

                title = title.substring(0, title.Length <= 60 ? title.Length : 60).trim();

                title = '/product/' + title;

                return title;
            }
        },
        watch: {
            listOptions: {
                handler(value) {
                    this.$emit('onChangeListOptions', value);
                },
                deep: true
            },
            comparisonList: {
                handler() {
                    this.modifyListForCompare();
                }
            },
            gridData: {
                handler() {
                    this.modifyListForCompare();
                }
            },

        }
    });
</script>
